import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.slice(1));
    const sessionId = params.get("session_id");
    const done = () => window.location.replace("/");
    if (!sessionId) { done(); return; }
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId, visitor_id: localStorage.getItem("dane_visitor_id") }),
        });
        if (!res.ok) throw new Error("auth failed");
        const data = await res.json();
        if (data.visitor_id) localStorage.setItem("dane_visitor_id", data.visitor_id);
        localStorage.setItem("dane_signed_in", "1");
        done();
      } catch {
        setFailed(true);
        setTimeout(done, 2500);
      }
    })();
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-callback">
      <p className="text-lg font-semibold text-[#D6D6D6] animate-pulse">
        {failed ? "Sign-in didn't go through — taking you back" : "Signing you in..."}
      </p>
    </div>
  );
};
